import axios from "axios";
import Config from "../../config/index";
import {
  CREATE_MACHINE_CENTER_FAILURE,
  CREATE_MACHINE_CENTER_REQUEST,
  CREATE_MACHINE_CENTER_SUCCESS,
  DELETE_DELETE_FAILURE,
  DELETE_DELETE_REQUEST,
  DELETE_DELETE_SUCCESS,
  GET_LOCATIONS_BY_MACHINE_FAILURE,
  GET_LOCATIONS_BY_MACHINE_REQUEST,
  GET_LOCATIONS_BY_MACHINE_SUCCESS,
  GET_MACHINE_CENTER_FAILURE,
  GET_MACHINE_CENTER_REQUEST,
  GET_MACHINE_CENTER_SUCCESS,
  GET_MACHINE_FOR_DROPDOWN_FAILURE,
  GET_MACHINE_FOR_DROPDOWN_REQUEST,
  GET_MACHINE_FOR_DROPDOWN_SUCCESS,
  GET_WORKCENTER_BY_MACHINE_FAILURE,
  GET_WORKCENTER_BY_MACHINE_REQUEST,
  GET_WORKCENTER_BY_MACHINE_SUCCESS,
  UPDATE_MACHINE_CENTER_FAILURE,
  UPDATE_MACHINE_CENTER_REQUEST,
  UPDATE_MACHINE_CENTER_SUCCESS,
  UPDATE_MACHINE_STATUS_REQUEST,
  UPDATE_MACHINE_STATUS_SUCCESS,
  UPDATE_MACHINE_STATUS_FAILURE,
  GET_MAPPED_MACHINES_REQUEST,
  GET_MAPPED_MACHINES_SUCCESS,
  GET_MAPPED_MACHINES_FAILURE,
} from "./machineCenterTypes";

let baseUrl = Config.baseUrl;

const getMachineCenterRequest = () => {
  return {
    type: GET_MACHINE_CENTER_REQUEST,
  };
};

const getMachineCenterSuccess = (payload) => {
  return {
    type: GET_MACHINE_CENTER_SUCCESS,
    payload: payload,
  };
};

const getMachineCenterFailure = (error) => {
  return {
    type: GET_MACHINE_CENTER_FAILURE,
    payload: error,
  };
};

const getMachineCenter = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getMachineCenterRequest());
    // let url = `${baseUrl}/machinecenter`;

    let url = `${baseUrl}/machinecenter?&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMachineCenterSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getMachineCenterFailure(err.response));
      });
  };
};

const getMachineCenterForDropDownRequest = () => {
  return {
    type: GET_MACHINE_FOR_DROPDOWN_REQUEST,
  };
};

const getMachineCenterForDropDownSuccess = (payload) => {
  return {
    type: GET_MACHINE_FOR_DROPDOWN_SUCCESS,
    payload: payload,
  };
};

const getMachineCenterForDropDownFailure = (error) => {
  return {
    type: GET_MACHINE_FOR_DROPDOWN_FAILURE,
    payload: error,
  };
};

const getMachineCenterForDropDown = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getMachineCenterForDropDownRequest());
    let url = `${baseUrl}/machinecenter_wop`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMachineCenterForDropDownSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getMachineCenterForDropDownFailure(err.response));
      });
  };
};
const getLocationsForMachineRequest = () => {
  return {
    type: GET_LOCATIONS_BY_MACHINE_REQUEST,
  };
};

const getLocationsForMachineSuccess = (payload) => {
  return {
    type: GET_LOCATIONS_BY_MACHINE_SUCCESS,
    payload: payload,
  };
};

const getLocationsForMachineFailure = (error) => {
  return {
    type: GET_LOCATIONS_BY_MACHINE_FAILURE,
    payload: error,
  };
};

const getLocationsForMachine = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getLocationsForMachineRequest());
    let url = `${baseUrl}/location_mc`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLocationsForMachineSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLocationsForMachineFailure(err.response));
      });
  };
};
const getWorkCenterRequest = () => {
  return {
    type: GET_WORKCENTER_BY_MACHINE_REQUEST,
  };
};

const getWorkCenterSuccess = (payload) => {
  return {
    type: GET_WORKCENTER_BY_MACHINE_SUCCESS,
    payload: payload,
  };
};

const getWorkCenterFailure = (error) => {
  return {
    type: GET_WORKCENTER_BY_MACHINE_FAILURE,
    payload: error,
  };
};

const getWorkCenter = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getWorkCenterRequest());
    let url = `${baseUrl}/workcenter`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWorkCenterSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWorkCenterFailure(err.response));
      });
  };
};

// const getLabelsWithPaginationRequest = () => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_REQUEST,
//   };
// };

// const getLabelsWithPaginationSuccess = (payload) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_SUCCESS,
//     payload: payload,
//   };
// };

// const getLabelsWithPaginationFailure = (error) => {
//   return {
//     type: GET_LABELS_WITH_PAGINATION_FAILURE,
//     payload: error,
//   };
// };

// const getLabelsWithPagination = (pageNo, rowsPerPage, search, jwtToken) => {
//   let headers = {
//     headers: {
//       Authorization: `Bearer ${jwtToken}`,
//     },
//   };

//   return (dispatch) => {
//     dispatch(getLabelsWithPaginationRequest());

//     let url = `${baseUrl}/label_size?page_number=${
//       pageNo + 1
//     }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

//     axios
//       .get(url, headers)
//       .then((response) => {
//         dispatch(getLabelsWithPaginationSuccess(response.data));
//       })
//       .catch((err) => {
//         dispatch(getLabelsWithPaginationFailure(err.response));
//       });
//   };
// };

const createMachineRequest = () => {
  return {
    type: CREATE_MACHINE_CENTER_REQUEST,
  };
};

const createMachineSuccess = (payload) => {
  return {
    type: CREATE_MACHINE_CENTER_SUCCESS,
    payload: payload,
  };
};

const createMachineFaliure = (error) => {
  return {
    type: CREATE_MACHINE_CENTER_FAILURE,
    payload: error,
  };
};

const createMachine = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(createMachineRequest());
    let url = `${baseUrl}/machinecenter`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createMachineSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createMachineFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateMachineCenterRequest = () => {
  return {
    type: UPDATE_MACHINE_CENTER_REQUEST,
  };
};

const updateMachineCenterSuccess = (payload) => {
  return {
    type: UPDATE_MACHINE_CENTER_SUCCESS,
    payload: payload,
  };
};

const updateMachineCenterFaliure = (error) => {
  return {
    type: UPDATE_MACHINE_CENTER_FAILURE,
    payload: error,
  };
};

const updateMachineCenter = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(updateMachineCenterRequest());
    let url = `${baseUrl}/machinecenter`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateMachineCenterSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateMachineCenterFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteMachineRequest = () => {
  return {
    type: DELETE_DELETE_REQUEST,
  };
};

const deleteMachineSuccess = (payload) => {
  return {
    type: DELETE_DELETE_SUCCESS,
    payload: payload,
  };
};

const deleteMachineFaliure = (error) => {
  return {
    type: DELETE_DELETE_FAILURE,
    payload: error,
  };
};

const deleteMachine = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteMachineRequest());
    let url = `${baseUrl}/machineCenter?machineCenterId=${id}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteMachineSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteMachineFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateMachineStatusRequest = () => {
  return {
    type: UPDATE_MACHINE_STATUS_REQUEST,
  };
};

const updateMachineStatusSuccess = (payload) => {
  return {
    type: UPDATE_MACHINE_STATUS_SUCCESS,
    payload: payload,
  };
};

const updateMachineStatusFailure = (error) => {
  return {
    type: UPDATE_MACHINE_STATUS_FAILURE,
    payload: error,
  };
};

const updateMachineStatus = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateMachineStatusRequest());
    let url = `${baseUrl}/machinecenter/availability`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateMachineStatusSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateMachineStatusFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getMappedMachinesRequest = () => {
  return {
    type: GET_MAPPED_MACHINES_REQUEST,
  };
};

const getMappedMachinesSuccess = (payload) => {
  return {
    type: GET_MAPPED_MACHINES_SUCCESS,
    payload: payload,
  };
};

const getMappedMachinesFailure = (error) => {
  return {
    type: GET_MAPPED_MACHINES_FAILURE,
    payload: error,
  };
};

const getMappedMachines = (operationId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getMappedMachinesRequest());
    let url = `${baseUrl}/machinecenter/operation_mapped?operationId=${operationId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMappedMachinesSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getMappedMachinesFailure(err.response));
      });
  };
};

export {
  getMachineCenter,
  createMachine,
  updateMachineCenter,
  deleteMachine,
  getLocationsForMachine,
  getWorkCenter,
  getMachineCenterForDropDown,
  updateMachineStatus,
  getMappedMachines,
};
